module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp12_6000.9cb88472.png";